import React from 'react'

function DashboardAboutSection() {
  return <>
    <div>Bu Sayfa Private AboutSection sayfasıdır</div>
  </>
}

export default DashboardAboutSection